import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted} from "vue";
import router from "@/router";
import jwt_decode from "jwt-decode";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {ErrorLocationType, PreferenceType} from "@/utilities/enums/Enums";
import {useGlobalStore} from "@/stores/GlobalStore";
import {UserService} from "@/utilities/services/entities/UserService";
import OAuthService from "@/utilities/services/OAuthService";
import {User} from "oidc-client";
import {UserPreference} from "@/models/user/UserPreference";
import {$t, i18n} from "@/utilities/i18n/config";
import {GeneralResponse} from "@/models/api/Responses";
import {MiscService} from "@/utilities/services/entities/MiscService";
import {notify} from "@kyvg/vue3-notification";
import {AccountService} from "@/utilities/services/entities/AccountService";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";



export default /*@__PURE__*/_defineComponent({
  __name: 'OAuthSsoCallback',
  setup(__props) {

const globalStore = useGlobalStore();
const userService = new UserService();
const miscService = new MiscService();
const accountService = new AccountService();

const setUserSettings = async(userId:string)=> {
  // get filters for user
  const filterResp = await userService.getUserPreferences(userId, PreferenceType.filter);
  // get hiddenColumns for User
  const columnResp = await userService.getUserPreferences(userId, PreferenceType.hiddenColumn);
  // get general settings for User
  const genSetResp = await userService.getUserPreferences(userId, PreferenceType.general);
  // get columnOrder settings for User
  const colOrderResp = await userService.getUserPreferences(userId, PreferenceType.columnOrder);

  if (filterResp?.statusCode === 0 && columnResp?.statusCode === 0 && genSetResp?.statusCode === 0 && colOrderResp?.statusCode === 0) {
    globalStore.setUserPreferences({
      userFilters: filterResp.preferenceInfo ?? [],
      userHiddenColumns: columnResp.preferenceInfo ?? [],
      userColumnOrder: colOrderResp.preferenceInfo ?? [],
      general: {
        darkMode: genSetResp.preferenceInfo.find((pi: UserPreference) => pi.attributeName === "darkMode")?.attributeValue ?? false,
        userStartPage: genSetResp.preferenceInfo.find((pi: UserPreference) => pi.attributeName === "userStartPage")?.attributeValue ?? "/account",
        userLocale: genSetResp.preferenceInfo.find((pi: UserPreference) => pi.attributeName === "userLocale")?.attributeValue ?? "de",
      },
    });

    // set language. if not null or undefined fallback to DE
    // @ts-expect-error
    i18n.global.locale.value = globalStore.userPreferences.general.userLocale;
  } else {
    ErrorHandler.handleError(new GeneralResponse(6666, "Ihre Einstellungen konnten nicht geladen werden"), ErrorLocationType.table);
  }
}

const setHubNotifs = async()=>{
  const notifResp = await miscService.getHubNotifications();

  if(notifResp?.statusCode === 0){
    globalStore.notifications = notifResp.notifications;
  }
  else{
    ErrorHandler.handleError(
        new GeneralResponse(6667, "Die Benachrichtigungen konnte nicht geladen werden"),
        ErrorLocationType.table
    );
  }
}

onMounted(async ()=> {
  const clientId = globalStore.settings.startupConfig?.clientId as string;
  const scopes = globalStore.settings.startupConfig?.clientScopes as string;
  const metaDataUrl = globalStore.settings.startupConfig?.metaDataUrl;
  const metaData = !NullOrUndefinedHelper(metaDataUrl) ? await miscService.getOidcMetaData(metaDataUrl as string) : undefined;
  const ssoCallback = "/sso/oAuthCallback";
  const ssoSilentCallback = "/sso/oAuthCallback/silent";

  const oAuthService = new OAuthService(globalStore.getAuthorityUrl(), clientId, scopes, ssoCallback, ssoSilentCallback, metaData);

  const userManager = oAuthService.userManager;
  try {
    const oAuthUser = await userManager.signinRedirectCallback() as User;

    console.log(oAuthUser)

    globalStore.setToken(oAuthUser.id_token);

    const exchangedToken = await accountService.exchangeToken(ErrorLocationType.login);
    if (exchangedToken === null){
      //TODO return to login? go to dedicated error page?
      return;
    }

    globalStore.setToken(exchangedToken);

    //@ts-expect-error
    const userResp = await userService.getUserById(jwt_decode(exchangedToken).id);
    if (userResp === null || userResp === undefined || userResp.statusCode !== 0) {
      ErrorHandler.handleError(userResp, ErrorLocationType.login);
    }

    globalStore.setUser(userResp.userInfo);

    await setUserSettings(userResp.userInfo.id);
    await setHubNotifs();

    //@ts-expect-error
    await router.push(globalStore.userPreferences.general.userStartPage);

    notify({
      title: "Erfolg",
      text: $t('login.notifySuccessfulLogin'),
      duration: 5000,
      type: "success"
    });
  }
  catch (e){
    console.error("Login failed:", e)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, " Waiting "))
}
}

})